import { render, staticRenderFns } from "./NEO-NARVAL.vue?vue&type=template&id=289ac584"
import script from "./NEO-NARVAL.vue?vue&type=script&lang=js"
export * from "./NEO-NARVAL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports